import { render, staticRenderFns } from "./CatalogueListItem.vue?vue&type=template&id=2b6c65d4&scoped=true&"
import script from "./CatalogueListItem.vue?vue&type=script&lang=ts&"
export * from "./CatalogueListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogueListItem.vue?vue&type=style&index=0&id=2b6c65d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c65d4",
  null
  
)

export default component.exports